import * as React from 'react';
import styled from 'styled-components';
import {transparentize} from 'polished';
import {transition} from 'helpers/css';
import {Theme} from '../../../stores/AppStore';

export interface StatisticSummaryProps {
  title: string;
  value: string | number;
  primary?: boolean;
  onClick?: () => void;
}

export const Container = styled.div<
  Pick<StatisticSummaryProps, 'primary'>
>`
  display: grid;
  gap: 4px;
  height: 79px;
  width: 190px;
  border-radius: 5px;
  padding: 10px;
  box-sizing: border-box;
  cursor: pointer;

  background: ${({primary, theme}) => {
    return primary
        ? theme.colors.primary
        : transparentize(.95, theme.variables.color);
  }};

  color: ${({primary, theme}) => {
    return theme.name === Theme.Dark ? primary
        ? theme.variables.color
        : transparentize(.6, theme.variables.color) : (
            primary
                    ? '#ffffff'
                    : transparentize(.6, theme.variables.color)
    );
  }};
  
  ${transition()}
`;

export const Title = styled.div`
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
  letter-spacing: 0.01em;
`;

export const Value = styled.div<Pick<StatisticSummaryProps, 'primary'>>`
  font-size: 22px;
  font-weight: 600;
  line-height: 29px;
  color: ${({theme, primary}) => theme.name === Theme.Dark ? theme.variables.color : (
    primary ? '#ffffff' : '#000000'
  )};
`;

/**
 * The function render Category item
 * @param {StatisticSummaryProps} props
 * @constructor
 */
export default function StatisticSummary(props: StatisticSummaryProps) {
  return (
    <Container primary={props?.primary} onClick={props?.onClick}>
      <Title>{props.title}</Title>
      <Value primary={props?.primary}>{props.value}</Value>
    </Container>
  );
}
